import { MessageCircle, Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface EmptySupportStateProps {
  onCreateTicket?: () => void;
}

export const EmptySupportState = ({ onCreateTicket }: EmptySupportStateProps) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center animate-fade-in">
      <div className="w-20 h-20 rounded-full bg-luxury-pinkBright/10 border border-luxury-pinkBright/20 flex items-center justify-center mb-6">
        <MessageCircle className="w-10 h-10 text-luxury-pinkBright" />
      </div>
      <h3 className="text-xl font-semibold mb-2 text-white">Nenhum ticket ainda</h3>
      <p className="text-white/60 max-w-sm mb-6">
        Você ainda não criou nenhum ticket de suporte. Crie seu primeiro ticket para falar com nossa equipe.
      </p>
      {onCreateTicket && (
        <Button
          onClick={onCreateTicket}
          className="bg-gradient-to-r from-[#C4406B] to-[#9F3764] hover:opacity-90 text-white font-medium px-6 py-3 rounded-lg flex items-center gap-2"
        >
          <Plus className="w-5 h-5" />
          Criar Primeiro Ticket
        </Button>
      )}
    </div>
  );
};
